import {
  Box,
  Button,
  Checkbox,
  createTheme,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Select as Select1,
  styled,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import returnCityNames from "../asset/js/CityNames";
import PostBidGeneralInfo from "./PostBidGeneralInfo";
import "./postbid-modern.css";
import { trackEventOnce } from "../asset/js/analytics";
function PostBid() {
  const [bidData, setBidData] = useState({});
  const [title, setTitle] = useState("");
  const [next, setNext] = useState(false);
  const [data, setData] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    trackEventOnce("publish_clicked", "postbid_page", {
      path: sessionStorage.getItem("biditAssistantDraft") ? "assistant" : "direct",
    });
  }, []);

  const [validTitle, setValidTitle] = useState(false);
  const cityNames = returnCityNames();
  const StyledBox = styled(Box)({
    margin: "0px auto",
    marginTop: "20px",
  });
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    anchorOrigin: { vertical: "bottom", horizontal: "right" },
    transformOrigin: { vertical: "top", horizontal: "right" },
    marginThreshold: 8,
    PaperProps: {
      className: "bidit-modern-area-menu",
      sx: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 290,
        mt: 0,
        borderRadius: "16px",
        boxShadow: "0 16px 40px rgba(20,60,95,.18)",
      },
    },
  };
  const handleChange1 = (event) => {
    const {
      target: { value },
    } = event;
    setArea(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const theme = createTheme({
    typography: {
      fontFamily: [
        "Assistant",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
  });
  const [area, setArea] = React.useState([]);
  const [time, setTime] = React.useState(1);
  const [title1, setTitle1] = React.useState("");
  const [assistantDraft, setAssistantDraft] = React.useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("biditAssistantDraft");
      if (!raw) return;
      const draft = JSON.parse(raw);
      if (!draft || !draft.title || !draft.description) return;
      // Ignore stale assistant drafts from an older browsing session.
      if (draft.createdAt && Date.now() - draft.createdAt > 2 * 60 * 60 * 1000) {
        sessionStorage.removeItem("biditAssistantDraft");
        sessionStorage.removeItem("biditAssistantReturnTo");
        return;
      }
      // Keep the AI's profession/area/duration as recommendations only.
      setAssistantDraft(draft);
      setTitle1(draft.title);
    } catch (err) {
      console.warn("Could not load Bidit assistant draft", err);
    }
  }, []);
  const handleChange = (event) => {
    event.preventDefault();
    const change = event.target.value;
    if (event.target.name === "time") {
      setTime(change);
    } else setTitle1(change);
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    const date = new Date();

    console.log(date.getTime());

    bidData.area = area;
    bidData.time = date.getTime() + time * 60 * 60;
    bidData.length = time * 60 * 60;
    setValidTitle(false);
    if (title1.length < 5) setValidTitle(true);

    if (!validTitle) {
      let area1 = "";
      for (let i = 0; i < area.length; i++) area1 += area[i];
      setBidData({
        title: title1 + " - " + area,
        area: area1,
        time: date.getTime() + time * 60 * 60 * 1000,
        length: time * 60 * 60 * 1000,
      });
      setNext(true);
    }
  };
  return (
    <div className="bidit-postbid-page">
      <StyledBox
        noValidate
        sx={{
          fontFamily: `${process.env.REACT_APP_FONT}`,
          mt: 1,
          width: { xs: "92%", sm: "85%", md: "70%" },
		  maxWidth: "600px", // width: { xs: "100%", md: "70%" },
		  px: 2, // padding אופקי

        }}
      >
        {!next && (
          <Box component="form" onSubmit={handleSubmit} className="bidit-form-card">
            <Box className="bidit-form-intro">
              <Box className="bidit-form-intro-badge">
                <span className="bidit-form-intro-spark">✦</span>
                מכרז חדש
              </Box>
              <Typography
                variant="h6"
                className="bidit-form-title"
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
              >
                בואו נפתח את המכרז שלכם
              </Typography>
              <Typography
                className="bidit-form-subtitle"
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
              >
                כמה פרטים קצרים והמכרז מוכן לפרסום
              </Typography>
            </Box>
            {assistantDraft && (
              <Box
                sx={{
                  mb: 2.5,
                  p: 2,
                  borderRadius: "14px",
                  backgroundColor: "#F2F8FD",
                  border: "1px solid #D5E8F6",
                }}
              >
                <Typography sx={{ fontFamily: "Assistant", fontWeight: 800, color: "#1B4D6B", mb: 0.7 }}>
                  הסייען הכין עבורך טיוטה
                </Typography>
                <Typography sx={{ fontFamily: "Assistant", fontSize: 14, color: "#526D7E" }}>
                  ההמלצות אינן נבחרות אוטומטית. אפשר לבחור כל מקצוע, אזור ומשך מכרז שתרצה.
                </Typography>
                {assistantDraft.recommendedArea && assistantDraft.recommendedArea !== "לא ידוע" && (
                  <Typography sx={{ mt: 1, fontFamily: "Assistant", fontSize: 14 }}>
                    <strong>אזור מומלץ:</strong> {assistantDraft.recommendedArea}
                  </Typography>
                )}
                {assistantDraft.recommendedDurationHours && (
                  <Typography sx={{ fontFamily: "Assistant", fontSize: 14 }}>
                    <strong>משך מומלץ:</strong> {({
                      0.166: "10 דקות", 0.5: "30 דקות", 1: "שעה", 3: "3 שעות", 6: "6 שעות",
                      12: "12 שעות", 24: "יום", 48: "יומיים", 72: "3 ימים", 96: "4 ימים",
                      120: "5 ימים", 144: "6 ימים", 168: "7 ימים"
                    })[assistantDraft.recommendedDurationHours] || "יום"}
                  </Typography>
                )}
              </Box>
            )}
            <Box className="bidit-field-heading">
              <Typography
                className="bidit-field-title"
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
              >
                מה צריך לעשות?
              </Typography>
              <Typography
                className="bidit-field-hint"
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
              >
                כתבו כותרת קצרה וברורה לעבודה
              </Typography>
            </Box>
            <ThemeProvider theme={theme}>
              <TextField
                margin="normal"
                sx={{
                  fontFamily: "Assistant",
                  marginBottom: "20px",
                }}
                required
                fullWidth
                value={title1}
                onChange={handleChange}
                id="title"
                placeholder="לדוגמה: התקנת מזגן בסלון"
                autoFocus
                name="title"
              />
            </ThemeProvider>
            {validTitle && (
              <p
                style={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  color: "red",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                הכותרת צריכה להיות לפחות 5 תווים
              </p>
            )}

            <InputLabel
              id="area"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                marginTop: "10px",
              }}
            >
              איפה העבודה מתבצעת?
            </InputLabel>
            <Select1
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                width: "100%",
                marginBottom: "10px",
                borderRadius: "14px",
                backgroundColor: "#fbfdff",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(25,118,210,.22)" },
              }}
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              placeholder="Enter Area"
              value={area}
              required
              onChange={handleChange1}
              input={<OutlinedInput label="Tag" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {[
                "צפון",
                "קרית שמונה והסביבה",
                "חיפה והסביבה",
                "ירושלים והסביבה",
                "נתניה והסביבה",
                "השרון והסביבה",
                "מרכז",
                "שפלה והסביבה",
                "באר שבע והסביבה",
                "דרום",
              ].map((name, i) => (
                <MenuItem
                  key={name}
                  value={name}
                  sx={{
                    fontFamily: `${process.env.REACT_APP_FONT}`,
                    flexDirection: "column",
                    alignItems: "stretch",
                    borderRadius: "12px",
                    fontSize: { xs: "80%", md: "100%" },
                    py: 1,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 1 }}>
                    <Checkbox
                      checked={area.indexOf(name) > -1}
                      sx={{ p: .4, "& .MuiSvgIcon-root": { fontSize: 23 }, "&.Mui-checked": { color: "#1976d2" } }}
                    />
                    <ListItemText primary={name} primaryTypographyProps={{ sx: { fontFamily: "Assistant", fontWeight: 800, color: "#173f62" } }} />
                  </Box>
                  <Box
                    display="block"
                    sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                  >
                    {name === "צפון" ? (
                      <Box>
                        {cityNames.southCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "קרית שמונה והסביבה" ? (
                      <Box>
                        {cityNames.northCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "חיפה והסביבה" ? (
                      <Box>
                        {cityNames.westCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "ירושלים והסביבה" ? (
                      <Box>
                        {cityNames.eastCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "נתניה והסביבה" ? (
                      <Box>
                        {cityNames.eCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "השרון והסביבה" ? (
                      <Box>
                        {cityNames.fCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "מרכז" ? (
                      <Box>
                        {cityNames.gCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "שפלה והסביבה" ? (
                      <Box>
                        {cityNames.hCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "באר שבע והסביבה" ? (
                      <Box>
                        {cityNames.iCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
                    ) : name === "דרום" ? (
                      <Box>
                        {cityNames.jCities.map((e) => {
                          return (
                            <Typography
                              variant="p"
                              display="block"
                              sx={{
                                fontFamily: `${process.env.REACT_APP_FONT}`,
                                color: "grey",
                                margin: "0px 3px",
                              }}
                            >
                              {e}
                            </Typography>
                          );
                        })}
                      </Box>
					 ) : (
                       ""
					 )}
                  </Box>
                </MenuItem>
              ))}
            </Select1>
            <InputLabel
              id="time"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                marginTop: "20px",
              }}
            >
              כמה זמן להשאיר את המכרז פתוח?
            </InputLabel>
            <Select
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                width: "100%",
              }}
              labelId="time"
              id="time"
              value={time}
              label="Time"
              name="time"
              onChange={handleChange}
            >
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={0.166}
              >
                10 דקות
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={0.5}
              >
                30 דקות
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={1}
              >
                1 שעה
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={3}
              >
                3 שעות
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={6}
              >
                6 שעות
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={12}
              >
                12 שעות
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={24}
              >
                1 יום
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={48}
              >
                2 ימים
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={72}
              >
                3 ימים
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={96}
              >
                4 ימים
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={120}
              >
                5 ימים
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={144}
              >
                6 ימים
              </MenuItem>
              <MenuItem
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                value={168}
              >
                7 ימים
              </MenuItem>
            </Select>
            <Button
              type="submit"
              className="bidit-primary-button"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, fontFamily: `${process.env.REACT_APP_FONT}` }}
            >
              ממשיכים לבחירת בעל מקצוע
            </Button>
          </Box>
        )}
        {next && <PostBidGeneralInfo bidData={bidData} assistantDraft={assistantDraft} />}
      </StyledBox>
    </div>
  );
}

export default PostBid;
